import { useMediaQuery } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'
import { MenuColumnFragment } from '../../operations.wp/types'
import Separator from '../separator/Separator'
import IconsMenu from './IconsMenu'
import Menu from './Menu'
import { HeaderStylesProps } from './Navigation'

const useStyles = makeStyles<Theme, HeaderStylesProps>(({ palette, spacing, breakpoints }) => ({
  hideOnMobile: {
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  menuContainer: {
    padding: spacing(2),
    width: '100%',
    [breakpoints.up('sm')]: {
      width: '45%',
    },
    [breakpoints.up('md')]: {
      width: '30%',
    },
  },
  separator: ({ textColor = palette.secondary.main }) => ({
    backgroundColor: textColor,
  }),
  thirdMenuContainer: {
    '& > div': {
      marginBottom: spacing(2),
    },
    [breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      display: 'flex',
      width: '100%',
    },
    [breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
}))

const Menus = ({
  ctas,
  menus,
  styles = {},
}: {
  ctas?: React.ReactNode | null
  menus: Array<{
    menu?: MenuColumnFragment | null
    separators?: {
      after?: boolean | null
      before?: boolean | null
    } | null
    socialsMenu?: MenuColumnFragment | null
  }>
  styles?: HeaderStylesProps
}) => {
  const classes = useStyles(styles)
  const { breakpoints } = useTheme<Theme>()
  const smDown = useMediaQuery(breakpoints.down('sm'))

  return (
    <>
      {smDown && ctas}
      {menus?.map(item => {
        if (item.socialsMenu) {
          return (
            <div
              key={item.menu?.id || item.socialsMenu.id}
              className={`${classes.menuContainer} ${classes.thirdMenuContainer}`}
            >
              {item.menu?.menuItems?.nodes?.length ? <Menu menu={item.menu} /> : null}

              {!smDown && ctas}

              {item.socialsMenu?.menuItems?.nodes?.length ? (
                <IconsMenu menu={item.socialsMenu} />
              ) : null}
            </div>
          )
        }
        if (!item.menu) return null
        return (
          <React.Fragment key={item.menu.id}>
            {item.separators?.before && (
              <Separator
                classes={[classes.separator, classes.hideOnMobile]}
                orientation="vertical"
              />
            )}
            <div key={item.menu?.id} className={classes.menuContainer}>
              <Menu menu={item.menu} />
            </div>
            {item.separators?.after && (
              <Separator
                classes={[classes.separator, classes.hideOnMobile]}
                orientation="vertical"
              />
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default Menus
